/* eslint-disable */
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CardTitle from "@saleor/components/CardTitle";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import FormSpacer from "@saleor/components/FormSpacer";
import S3FilesAndImagesDialog from "@saleor/s3/components";
import React, { useState } from "react";
import { useIntl } from "react-intl";

interface ProductVariantColorProps {
  fromColor: string;
  toColor: string;
  colorThumbnail: string;
  setColorThumbnail;
  isTwoColor: boolean;
  onChange: (event: React.ChangeEvent<any>) => void;
  disabled: boolean;
  colorTagText: string;
  colorTagBackground: string;
  colorTagTextColor: string;
  // colorTagIcon: string;
  // setColorTagIcon;
}
const ProductVariantColor: React.FC<ProductVariantColorProps> = ({
  fromColor,
  toColor,
  isTwoColor,
  colorThumbnail,
  setColorThumbnail,
  onChange,
  disabled,
  colorTagText,
  colorTagBackground,
  colorTagTextColor
  // colorTagIcon,
  // setColorTagIcon
}) => {
  const intl = useIntl();

  const [s3open, setS3Open] = useState(false);
  // const [s4open, setS4Open] = useState(false);
  const [currentS3Media, setcurrentS3Media] = useState("");
  const [currentS3MediaType, setCurrentS3MediaType] = useState("image");

  // 选择更新视频或图片素材
  const loadS3Media = () => {
    const src_url = colorThumbnail;
    if (
      src_url.indexOf(".jpg") > 0 ||
      src_url.indexOf(".png") > 0 ||
      src_url.indexOf(".gif") > 0 ||
      src_url.indexOf(".webp") > 0
    ) {
      setCurrentS3MediaType("image");
    } else if (src_url.indexOf(".mp4") > 0) {
      setCurrentS3MediaType("video");
    }
    setcurrentS3Media(src_url);
    setS3Open(true);
  };

  // const loadS3Media2 = () => {
  //   const src_url = colorTagIcon;
  //   if (
  //     src_url.indexOf(".jpg") > 0 ||
  //     src_url.indexOf(".png") > 0 ||
  //     src_url.indexOf(".gif") > 0 ||
  //     src_url.indexOf(".webp") > 0
  //   ) {
  //     setCurrentS3MediaType("image");
  //   } else if (src_url.indexOf(".mp4") > 0) {
  //     setCurrentS3MediaType("video");
  //   }
  //   setcurrentS3Media(src_url);
  //   setS4Open(true);
  // };

  //
  //

  return (
    <>
      <Card>
        <CardTitle
          title={intl.formatMessage({
            defaultMessage: "SKU Color",
            description: "sku color"
          })}
        />
        <CardContent>
          <TextField
            style={{ width: "100%" }}
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "From Color"
            })}
            name="fromColor"
            value={fromColor}
            onChange={onChange}
          />
          <FormSpacer />
          <TextField
            style={{ width: "100%" }}
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "To Color"
            })}
            name="toColor"
            value={toColor}
            onChange={onChange}
          />
          <FormSpacer />

          <ControlledCheckbox
            name={"isTwoColor"}
            label={intl.formatMessage({
              defaultMessage: "is Two-Tone",
              description: "isTwoColor"
            })}
            checked={isTwoColor}
            onChange={onChange}
            disabled={disabled}
          />
          <FormSpacer />

          <TextField
            style={{ width: "80%" }}
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Color Thumbnail"
            })}
            name="colorThumbnail"
            value={colorThumbnail}
            onChange={onChange}
          />
          <CloudUploadIcon
            style={{
              marginLeft: 20,
              width: 40,
              height: 40,
              cursor: "pointer"
            }}
            color="primary"
            onClick={loadS3Media}
          />

          {s3open && (
            <S3FilesAndImagesDialog
              open={s3open}
              onClose={() => {
                setS3Open(false);
              }}
              defaultCurrentS3Media={"products"}
              setShowS3Media={setS3Open}
              currentS3Media={currentS3Media}
              currentS3MediaType={currentS3MediaType}
              onSelectS3Media={setColorThumbnail}
            />
          )}
          <FormSpacer />
          {colorThumbnail ? (
            <img
              src={colorThumbnail}
              style={{
                width: "100px",
                height: "100px",
                overflow: "hidden",
                objectFit: "cover"
              }}
            />
          ) : fromColor ? (
            toColor ? (
              isTwoColor ? (
                <div
                  style={{
                    background: `linear-gradient(135deg, ${fromColor} 50%, ${toColor} 50%)`,
                    width: "100px",
                    height: "100px",
                    marginRight: "20px",
                    textAlign: "center",
                    paddingTop: "5px"
                  }}
                />
              ) : (
                <div
                  style={{
                    background: `linear-gradient(to right, ${fromColor} 0%,${toColor} 100%)`,
                    width: "100px",
                    height: "100px",
                    marginRight: "20px",
                    textAlign: "center",
                    paddingTop: "5px"
                  }}
                />
              )
            ) : (
              <div
                style={{
                  background: fromColor,
                  width: "100px",
                  height: "100px",
                  marginRight: "20px",
                  textAlign: "center",
                  paddingTop: "5px"
                }}
              />
            )
          ) : (
            ""
          )}

          <FormSpacer />
          <TextField
            style={{ width: "100%" }}
            label={intl.formatMessage({
              defaultMessage: "Color Tag Text"
            })}
            name="colorTagText"
            disabled={disabled}
            value={colorTagText}
            onChange={onChange}
          />

          <FormSpacer />
          <TextField
            style={{ width: "100%" }}
            label={intl.formatMessage({
              defaultMessage: "Color Tag TextColor"
            })}
            name="colorTagTextColor"
            disabled={disabled}
            value={colorTagTextColor}
            onChange={onChange}
          />

          <FormSpacer />
          <TextField
            style={{ width: "100%" }}
            label={intl.formatMessage({
              defaultMessage: "Color Tag Background"
            })}
            name="colorTagBackground"
            disabled={disabled}
            value={colorTagBackground}
            onChange={onChange}
          />

          <FormSpacer />
          {/* <TextField
            style={{ width: "80%" }}
            label={intl.formatMessage({
              defaultMessage: "Color Tag Icon"
            })}
            name="colorTagIcon"
            disabled={disabled}
            value={colorTagIcon}
            onChange={onChange}
          /> */}

          {/* <CloudUploadIcon
            style={{
              marginLeft: 20,
              width: 40,
              height: 40,
              cursor: "pointer"
            }}
            color="primary"
            onClick={loadS3Media2}
          /> */}

          {/* {s4open && (
            <S3FilesAndImagesDialog
              open={s4open}
              onClose={() => {
                setS4Open(false);
              }}
              defaultCurrentS3Media={"color"}
              setShowS3Media={setS4Open}
              currentS3Media={currentS3Media}
              currentS3MediaType={currentS3MediaType}
              onSelectS3Media={setColorTagIcon}
            />
          )} */}

          <FormSpacer />
          {colorTagText && (
            <div
              style={{
                background: colorTagBackground,
                width: "100px",
                height: "30px",
                marginRight: "20px",
                textAlign: "center",
                paddingTop: "5px"
              }}
            >
              <span style={{ color: colorTagTextColor }}>{colorTagText}</span>
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default ProductVariantColor;
